import { render, staticRenderFns } from "./DadosEventosForm.vue?vue&type=template&id=b1cca54c"
import script from "./DadosEventosForm.vue?vue&type=script&lang=js"
export * from "./DadosEventosForm.vue?vue&type=script&lang=js"
import style0 from "./DadosEventosForm.vue?vue&type=style&index=0&id=b1cca54c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports